import{variant2}from"../../utils/variantConfig";const componentConfig=Object.freeze({[variant2]:{iconBackGround:"white"}});export default componentConfig;